const Qs = require('qs')
const baseUrl = 
    (process.env.MIX_API_URL == 'https://api.guestflip.io' ? 'https://staging-api.guestflip.io/' : process.env.MIX_API_URL)
    + '/private/messaging/';

const MessagingService = {
    conversations: {
        index: async (teamId) => {
            const response = await axios({
                method: 'get',
                url: `/conversations/${teamId}`,
                baseURL: baseUrl,
                headers: {
                    'Authorization': Spark.jwtToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })

            const responseData = await response.data
            return responseData;
        },
        respond: async (conversationId, message) => {
            const response = await axios({
                method: 'post',
                url: `/conversations/${conversationId}/respond`,
                baseURL: baseUrl,
                data: {
                    message
                },
                headers: {
                    'Authorization': Spark.jwtToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })

            const responseData = await response.data
            return responseData;
        }
    },
    events: {
        index: async (conversationId) => {
            const response = await axios({
                method:'get',
                url: `/events/${conversationId}?access_code=`,
                baseURL: baseUrl,
                headers: {
                    'Authorization': Spark.jwtToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })

            const responseData = await response.data
            return responseData;
        }
    }
}

export default MessagingService;